var render = function (_h,_vm) {var _c=_vm._c;return _c('div',[_vm._v("\n    "+_vm._s(_vm.$t('Unsupported response type: {type}', {type: _vm.props.item.response_type}))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }